module.exports = __webpack_public_path__ + "static/media/transport.47b63901.png";